!(function (o, n, e) {
	const wsID = "chrot0rvq9l2v64oigb0";
	const cID = "chrot0rvq9l2v64oigbg";
	const d = "53b6cc6fd6dd9ec77ce8.kazaarfragrances.ch";
	const fbp = ["588942028669496"];
	const ttp = ["CLF06GJC77U8PKBJSGAG"];
	const cM = false;

	o.__cIDs = o.__cIDs || [];
	o.__cIDs.push(cID);

	o.__getcIDs = () => o.__cIDs;

	o[cID] = {
		ss: [
			{
				wsID,
				cID,
				d,
				a: true,
			},
		],
		ep: {
			facebookPixel: fbp,
			tiktokPixel: ttp,
		},
		t: {
			project:
				new URL(window.location.href).hostname
					.split(".")
					.slice(-2, -1)[0] || "kazaarCH",
			host: document.location.host,
		},
		l: {
			ttl: 10,
			a: true,
			idpE: true,
			idpP: true,
		},
		cM,
	};

	function ls(n, d, s) {
		let promises = s.map((e) => {
			return new Promise((resolve, reject) => {
				let x = n.createElement("script");
				x.async = true;
				x.src = `https://${d}/cdn/scripts/${e}.js`;
				x.onload = resolve;
				x.onerror = reject;
				n.body.appendChild(x);
			});
		});
		return Promise.all(promises);
	}

	let x = n.createElement(e);
	x.async = true;
	x.src = `https://${d}/cdn/scripts/ot_b.js`;

	x.onload = function () {
		ls(n, d, ["ot_asl"])
			.then(() => {
				window[window.__getcIDs()[0]].setConsent();
			})
			.catch((error) => {
				console.error("Failed to load some scripts:", error);
			});
	};

	let y = n.getElementsByTagName(e)[0];
	y.parentNode.insertBefore(x, y);
})(window, document, "script");
